// extracted by css-extract-rspack-plugin
var _1 = "xFcWcOpfxB-arBh2IKiZ1g--";
export { _1 as "badge" }
